import React, { Fragment } from 'react';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { translate } from '../../../Services/translation';

const StyledSpecificationTab = styled.div`
  display: flex;
  justify-content: center;
  table {
    overflow-x: auto;
    display: block;
    tbody {
      border-radius: 0.4rem;
      border-top: 1px solid ${getColor('gray', 300)};
      td {
        border-bottom: 1px solid ${getColor('gray', 300)};
        border-right: 1px solid ${getColor('gray', 300)};
        padding: 0.8rem;
        min-width: 100px;
      }
      tr {
        border-left: 1px solid ${getColor('gray', 300)};
        &:nth-of-type(odd) {
          background-color: white;
        }
        &:nth-of-type(even) {
          background-color: ${getColor('gray', 100)};
        }
      }
    }
  }
`;

const SpecificationTab = ({ specifications, showSpecificationsDefaultText }) => {
  return (
      <StyledSpecificationTab>
        {showSpecificationsDefaultText
        ? translate('product.no.selected.variant.specification') :
        <table>
          <tbody>
            {specifications.productFields.map((field, idx) => (
              <Fragment key={field.name + idx}>
                {field.value && (
                  <tr>
                    <td>{field.name}</td>
                    <td>{field.value}</td>
                  </tr>
                )}
              </Fragment>
            ))}
          </tbody>
        </table>
      }
    </StyledSpecificationTab>
  );
};

export default SpecificationTab;
